import { VisitDeliveryImage, VisitDtImage, VisitTableImage, VisitTogoImage } from '@local/assets/images'

import { BizItemType } from '@web/federation/gql/graphql'
import { OrderTimelineType } from '@web/libs/constants'

export const bookingIconUrlMap: Record<BizItemType | OrderTimelineType, { iconUrl: string; name: string }> = {
  PICKUP: { iconUrl: VisitTogoImage.src, name: '포장 주문' },
  DELIVERY: { iconUrl: VisitDeliveryImage.src, name: '배달 주문' },
  DELIVERY_ROBOT: { iconUrl: VisitDeliveryImage.src, name: '배달 주문' },
  DRIVETHRU: { iconUrl: VisitDtImage.src, name: 'DT 주문' },
  DRIVE_THRU: { iconUrl: VisitDtImage.src, name: 'DT 주문' },
  TABLE_ORDER: { iconUrl: VisitTableImage.src, name: '테이블 주문' },
  VISIT: { iconUrl: VisitTableImage.src, name: '테이블 주문' },
  STANDARD: { iconUrl: VisitTogoImage.src, name: '일반' }, // TODO: 일반 아이콘 확인 필요
}
